import { Link } from '@tanstack/react-router';
import { Button } from '../ui/button';

export function NotFoundPage() {
    return (
        <div className="min-h-screen flex flex-col items-center justify-center gap-4">
            <h1 className="text-3xl font-bold">404</h1>
            <p className="text-muted-foreground">La página que buscas no existe.</p>
            <Button asChild>
                <Link to="/">Volver al inicio</Link>
            </Button>
        </div>
    );
}
